import {Vue} from 'ui.vue';
import {directivePhone} from 'regza.vue.directives.phone';
import './style.css';
let requestForm = Vue.component('v-request-call', {
  template: `
              <div class="box-shadow-lg card">
                            <div class="card-body">
                                <template v-if="!formSuccess">
                                  <h5 class="dark-color m-20px-b">Оставьте свои контактные данные</h5>
                                  <form>
                                    <div class="form-group">
                                        <input 
                                        :class="{'is-invalid':!!errors.NAME}"
                                        @input="validate('NAME')" 
                                        v-model="user.NAME" 
                                        class="form-control" 
                                        type="text" 
                                        autocomplete="off"
                                        placeholder="Ваше имя">
                                        <small v-if="errors.NAME" class="form-control-feedback">{{errors.NAME}}</small>
                                    </div>
                                    <div class="form-group">
                                          <input
                                          v-phone
                                          :class="{'is-invalid':!!errors.PHONE_NUMBER}"
                                          @input="validate('PHONE_NUMBER')" 
                                          v-model="user.PHONE_NUMBER" 
                                          class="form-control" 
                                          type="text"
                                          placeholder="Ваш телефон">
                                  <small v-if="errors.PHONE_NUMBER" class="form-control-feedback">{{errors.PHONE_NUMBER}}</small>
                                    </div>
                                    <div class="form-group">
                                        <input 
                                        :class="{'is-invalid':!!errors.EMAIL}"
                                        @input="validate('EMAIL')" 
                                        v-model="user.EMAIL" 
                                        class="form-control" 
                                        type="email" 
                                        autocomplete="off"
                                        placeholder="Ваше email">
                                        <small v-if="errors.EMAIL" class="form-control-feedback">{{errors.EMAIL}}</small>
                                    </div>
                                    <div class="form-group">
                                         <textarea  v-model="user.COMMENTS" rows="4" class="form-control" placeholder="Ваше сообщение"></textarea>
                                    </div>
                                    <div>
                                        <button type="button" @click="save" class="m-btn m-btn-theme m-btn-radius w-100">Заказать демонстрацию</button>
                                    </div>
                                </form>
                                </template>
                                <div v-else role="alert">{{formSuccessText}}</div>
                            </div>
                        </div>`,
  directives:{
    directivePhone
  },
  props: {
    userData: {
      type: Object,
      default() {
        return {
          NAME:'',
          PHONE_NUMBER:'',
          EMAIL:'',
          COMMENTS:''
        };
      }
    },

  },
  model: {
    prop: 'userData',
    event: 'input-data'
  },
  watch: {
    userData: {
      deep: true,
      handler: function () {
        this.user = {...this.userData};
      }
    }
  },
  data() {
    return {
      formSuccess:false,
      formSuccessText:'',
      user: {...this.userData},
      validators: {
        PHONE_NUMBER: [
          function (data) {
            let value = data['PHONE_NUMBER'];
            let valid = /^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{7,10}$/i.test(value);
            // let valid = /^(?:^[0-9]{2}$|^[+]{0,1}(?:[-\/.\s()\[\]~;#,]*[0-9]){3,}[-\/.\s()\[\]~;#,0-9]*$)$/i.test(value);
            return {
              valid: valid,
              message: !valid ? 'Не верный формат телефона' : ''
            }
          }.bind(this)
        ],
        EMAIL: [
          function (data) {
            let value = data['EMAIL'];
            if(value.length <= 0){
              return {
                valid: true,
                message:  ''
              }
            }
            let valid = /^[=_.0-9a-z+~'-]+@(([-0-9a-z_]+\.)+)([a-z]{2,10})$/i.test(value);
            return {
              valid: valid,
              message: !valid ? 'Не верный формат эл. почты' : ''
            }
          }.bind(this)
        ],

        NAME: [
          function (data) {
            let value = data['NAME'];
            let valid = value != '';
            return {
              valid: valid,
              message: !valid ? 'Не может быть пустым' : ''
            }
          }.bind(this),
          function (data) {
            let value = data['NAME'];
            let valid = /^[а-яА-яa-zA-Z]+(([-,\s][а-яА-яa-zA-Z])?[а-яА-Яa-zA-Z]*)*$/i.test(value);
            return {
              valid: valid,
              message: !valid ? 'Только буквы' : ''
            }
          }.bind(this)
        ],

      },
      errors: {}
    }
  },
  computed: {

  },
  methods: {
    validate(field) {
      let arFunctions = this.validators[field];

      if (!Array.isArray(arFunctions) || arFunctions.length <= 0) {
        return;
      }

      for (let validate of arFunctions) {

        let res = validate(this.user);
        if (!res.valid) {
          this.$set(this.errors,field,res.message)
          // this.errors[field] = res.message;
          return;
        }
      }
      this.$delete(this.errors,field);
    },
    onsuccess(res){
      let data = res.data;
      this.formSuccess = true;
      this.formSuccessText = data.message;
      this.$emit('input-data', {...this.user});
      this.$emit('user-save', {...this.user});
    },
    onError(e){
      if(Array.isArray(e.errors)){
          e.errors.forEach((error)=>{
            this.$set(this.errors,error.code, error.message);
          })

      }
    },
    save() {

      Object.keys(this.validators).forEach(function(keyField){
        this.validate(keyField);
      }, this);
      if(Object.keys(this.errors).length >0){
        return;
      }
      BX.ajax.runAction('ajax:routs.request.Form.requestCallBack', {
        data: {
          phone:this.user.PHONE_NUMBER,
          name:this.user.NAME,
          email:this.user.EMAIL,
          comments:this.user.COMMENTS
        }
      })
        .then(this.onsuccess)
        .catch(this.onError)


    },
  }
});
export {
  requestForm
};